import { isValidPositiveInteger } from '@utriper/core';
import { fetch, Method } from 'core/api/fetch';

const BookingRoutes = {
    reserve: '/api/v2.0/booking',
};

const parseBookingItemUnits = (units = []) => units?.map((unit) => ({ unitLinkId: unit?.id, quantity: unit?.quantity }));

const parseBookingItem = (bookingItem, overrideAvailability = false) => {
    const hasUnits = Array.isArray(bookingItem?.units) && bookingItem?.units?.length > 0;

    let bookingItemParsed = {
        experienceDetailId: bookingItem.experienceDetailId,
        availabilityId: bookingItem?.availabilityId || null,
        units: hasUnits ? parseBookingItemUnits(bookingItem.units) : [],
    };

    if (isValidPositiveInteger(bookingItem?.bundleId)) {
        bookingItemParsed.bundleId = bookingItem.bundleId;
    }

    if (Array.isArray(bookingItem?.resources)) {
        bookingItemParsed.resourcesSelected = bookingItem.resources;
    }

    if (overrideAvailability) {
        Object.assign(bookingItemParsed, {
            price: bookingItem?.price,
            currency: bookingItem?.currency,
            dateUTC: bookingItem?.dateUTC,
            timezone: bookingItem?.timezone,
            duration: bookingItem?.duration,
            payNow: bookingItem?.payNow,
        });
    }

    return bookingItemParsed;
};

export const BookingServiceV2 = {
    reserve: async ({ items = [], triper, contractId, paymentPlatformId, isPendingTour, overrideAvailability, hostAgent, additional }) => {
        try {
            const itemsParsed = items?.map(parseBookingItem, overrideAvailability);

            const { data } = await fetch(BookingRoutes.reserve, {
                method: Method.POST,
                authenticated: true,
                data: {
                    items: itemsParsed,
                    triper,
                    contractId,
                    paymentPlatformId,
                    isPendingTour,
                    overrideAvailability,
                    hostAgent,
                    additional,
                },
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            return data;
        } catch (error) {
            throw error;
        }
    },
};
